$(function(){
    $('.product #a-show-description').click(function(){
        $('.product .product__description').slideToggle();
    });
    $('a[href="#more"]').click(function(){
        $('.div-more').slideToggle();
        return false;
    });
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });
    if ( $('.product .swiper-selos').length == 1 ) {
        const swiper = new Swiper('.swiper-selos', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 3,
            spaceBetween: 12,
            // Navigation arrows
            navigation: {
                nextEl: '.slider-button--next',
                prevEl: '.slider-button--prev',
            },
        });
    }
    // venda de tickets
    if ($('#tickets').length>0 && $('#calendar').length>0) {
        const agora = new Date();
        const data = agora.toLocaleDateString('pt-BR');
        const hora = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        const data_consulta = `${data} às ${hora}`;
        $('#data-consulta').html(data_consulta);
        var date = new Date(); // Now
        const calendarStart = date.toISOString().slice(0, 8) + '01'; //console.log(calendarStart);
        date.setDate(date.getDate() + 120); // Set now + 120 days as the new date
        const calendarEnd = date.toISOString().slice(0, 8) + '31'; //console.log(calendarEnd);
        var calendarEl = document.getElementById('calendar');
        var calendar = new FullCalendar.Calendar(calendarEl, {
            initialView: 'dayGridMonth',
            locale: 'pt-br',
            validRange: {
                start: calendarStart, // hoje ou amanhã (dependendo do horário)
                end: calendarEnd // três meses adiante
            },
            navLinks: true,
            navLinkDayClick: function(date, jsEvent) {
                //console.log(date);
                //console.log(jsEvent);
                //$('#calendar, #shopify-section-template--19891932659805__rich_text_KaC8wP p, #shopify-section-template--19891932659805__collapsible_content_EYAp6Q').hide();
                $('#result').show();
                $('#result').html('Carregando horários. Aguarde! <br><br> <img src="https://cdn.shopify.com/s/files/1/0673/7208/9437/files/loading.gif?v=1775041902">')
                $('body,html').stop().animate({ scrollTop:$('#result').offset().top-100 }, 500, 'swing');
                $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=horarios&date='+date.toISOString()+'&guid=&guid_newapi=', function(ret){
                    $('#result').html(ret);
                });
            },
        });
        calendar.render();
        const urlParams = new URLSearchParams(window.location.search);
        var guia_id = parseInt(urlParams.get('guia_id'));
        if (!isNaN(guia_id)) {
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=get-nome-guia&guia_id='+guia_id, function(ret){
                $('#guia').html(ret);
            });
        }
        if ( $(window).width() <= 768 ) {
            tmp = setTimeout(function(){
                $('.fc-view-harness').height(
                    $('.fc-scrollgrid-sync-table tr').length * 43 + 35
                );
            },1000);
        }
        $(document).on('change','select#hora',function(){
            if ($('select#hora option:selected').val()!='') {
                $('#qtde').show();
                if ( $('#horario_id').length ==1 ) {
                    $('#horario_id').val( $('select#hora option:selected').attr('data-horario-id') );
                }
            }
            else {
                $('#qtde').hide();
            }
        });
        $(document).on('change','#qtde input',function(){
            qtde_individual = parseInt($('#qtde_individual').val());
            qtde_infantil = parseInt($('#qtde_infantil').val());
            tickets = qtde_individual + qtde_infantil;
            vagas = $('select#hora option:selected').attr('data-vagas');
            if ( qtde_infantil > (qtde_individual*3) ) {
                alert('Para cada ingresso individual você pode reservar até 3 ingressos infantis.');
                $('#qtde_infantil').val( parseInt(qtde_individual*3) );
            }
            else if (tickets > vagas) {
                $('#continue,#total').hide().find('button').attr('disabled',true);
            }
            else if (tickets>0) {
                $('#total').show().find('span').each(function(){
                    var obj_total = $(this).parent();
                    var unitario = 50;
                    $('#qtde_individual').each(function(){
                        unitario = parseInt($(this).attr('data-preco'));
                        qtde = parseInt($(this).val());
                        total = unitario*qtde;
                        //console.log(total);
                        if (total>0) {
                            desconto = parseInt($('#desconto span').html());
                            if (!isNaN(desconto)) total-=desconto;
                            $('#continue,#cupom').show().find('button').attr('disabled',false);
                            obj_total.find('span').html(total);
                        }
                        else {
                            $('#continue,#cupom,#total').hide().find('button').attr('disabled',true);
                            obj_total.find('span').html(total);
                        }
                    });
                });
            }
            else {
                $('#continue,#cupom,#total').hide().find('button').attr('disabled',true);
            }
        }).on('focus','#qtde input',function(){
            if ($(this).val()=='0') {
                $(this).val('');
            }
        }).on('blur','#qtde input',function(){
            if ($(this).val()=='') {
                $(this).val('0');
            }
        });
        $(document).on('submit','form#etapa2',function(){
            vagas = $('select#hora option:selected').attr('data-vagas');
            total = parseInt($('#qtde_individual').val()) + parseInt($('#qtde_infantil').val());
            if (total > vagas) {
                alert('Selecione uma quantidade menor de ingressos ou escolha um horário com vagas suficientes.');
            }
            else {
                $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=tickets-etapa3', $(this).serialize(),function(ret){
                    $('#result').html(ret);
                });
            }
            return false;
        });
        $(document).on('submit','form#etapa3',function(){
            if ( $('#termos:hidden').length > 0 ) {
                if ($('#ipt-name').val()=='') {
                    alert('Informe o nome completo');
                    $('#ipt-name').focus();
                    return false;
                }
                if ($('#ipt-email').val()=='') {
                    alert('Informe um e-mail válido');
                    $('#ipt-email').focus();
                    return false;
                }
                if ($('#ipt-email').val()!=$('#ipt-email2').val()) {
                    alert('Verifique os valores preenchidos nos campos e-mail e confirme seu e-mail. Estão diferentes.');
                    $('#ipt-email').focus();
                    return false;
                }
                if ($('#ipt-phone').val()=='') {
                    alert('Informe um celular válido');
                    $('#ipt-phone').focus();
                    return false;
                }
                $('#str-name').html($('#ipt-name').val());
                $('#str-email').html($('#ipt-email').val());
                $('#str-phone').html($('#ipt-phone').val());
                $('#dados-pessoais').slideUp('fast',function(){
                    $('#termos').slideDown('fast');
                    $('#continue button').html('Entendi');
                });
            }
            else {
                $('#continue button').prop('disabled',true).html('Gerando ingresso(s). Aguarde!').css('cursor','default');
                const urlParams = new URLSearchParams(window.location.search);
                var guia_id = parseInt(urlParams.get('guia_id'));
                if (isNaN(guia_id)) {
                    guia_id = 0;
                }
                $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=tickets-etapa4&guia_id='+guia_id, $(this).serialize(),function(ret){
                    if (ret.indexOf('erro:')<0) {
                        if ( ret.indexOf('https')==0 ) location.href=ret;
                        else $('#result').html(ret);
                    }
                    else {
                        alert(ret);
                        $('#termos').slideUp('fast',function(){
                            $('#dados-pessoais').slideDown('fast');
                            $('#continue button').prop('disabled',false).html('Entendi').css('cursor','pointer');
                        });
                    }
                });
            }
            return false;
        });
        $(document).on('click','#cupom button',function(){
            if ($.trim($('#cupom-input').val())=='') {
                $('#cupom p').html('Informe o código do cupom.');
            }
            else {
                $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=cupom-validate&key='+$('#cupom-input').val(),
                    function(ret){
                        //console.log(ret);
                        if ( ret=='0' || ret=='' || isNaN(ret) ) {
                            $('#cupom p').html('Cupom inválido ou já utilizado.');
                            $('#desconto').hide().find('span').html('');
                        }
                        else {
                            if ( parseInt(ret)>0 ) {
                                $('#desconto').show().find('span').html(ret);
                                $('#cupom p').html('');
                                var unitario = 50;
                                var obj_total = $('#total')
                                $('#qtde_individual').each(function(){
                                    unitario = parseInt($(this).attr('data-preco'));
                                    qtde = parseInt($(this).val());
                                    total = unitario*qtde;
                                    //console.log(total);
                                    if (total>0) {
                                        desconto = parseInt($('#desconto span').html());
                                        if (!isNaN(desconto)) total-=desconto;
                                    }
                                    obj_total.find('span').html(total);
                                });
                            }
                        }
                        $('#qtde input').trigger('change');
                    }
                );
            }
        });
    }

    // exibe os ingressos
    if ($('#tickets-success').length>0) {
        const urlParams = new URLSearchParams(window.location.search);
        const external_reference = urlParams.get('external_reference');
        if (external_reference) {
            $('#tickets-success').html('<br> Carregando. Aguarde! <br> <img src="https://cdn.shopify.com/s/files/1/0673/7208/9437/files/loading.gif?v=1775041902">');
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=tickets-success&external_reference='+external_reference,
                function(ret){
                    $('#tickets-success').html(ret);
                }
            );
        }
    }

    // esconde o titulo no retorno do mercado pago
    if (location.href.indexOf('/pages/tickets-success')>0 || location.href.indexOf('/pages/tickets-failure')>0) {
        $('.main-page-title').css({'text-align':'center','margin-top':'1em'});
    }

    // venda de cupons
    if ($('#form-cupom').length>0 && $('#qtde').length>0) {
        $('#qtde input').on('change', function() {
            qtde_cupons = parseInt($('#qtde_cupons').val());
            if (qtde_cupons > 0) {
                $('#total').show().find('span').each(function() {
                    var obj_total = $(this).parent();
                    var unitario = 50;
                    $('#qtde_cupons').each(function() {
                        unitario = parseInt($(this).attr('data-preco'));
                        qtde = parseInt($(this).val());
                        total = unitario * qtde;
                        if (total > 0) {
                            $('#continue').show().find('button').attr('disabled', false);
                            obj_total.find('span').html(total);
                        } else {
                            $('#continue,#total').hide().find('button').attr('disabled', true);
                            obj_total.find('span').html(total);
                        }
                    });
                });
            } else {
                $('#total span').html('0');
                $('#continue,#total').find('button').attr('disabled', true);
            }
        }).on('focus', function() {
            if ($(this).val() == '0') {
                $(this).val('');
            }
        }).on('blur', function() {
            if ($(this).val() == '') {
                $(this).val('0');
            }
        });
        $('#form-cupom form').on('submit', function() {
            total = parseInt($('#qtde_cupons').val());
            if (total <= 0) {
                alert('Selecione uma quantidade maior de cupom(ns).');
            } else {
                //console.log($(this).serialize());
                $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=cupom-buy', $(this).serialize(), function(ret) {
                    if (ret.indexOf('erro:') < 0) {
                        location.href = ret;
                    } else {
                        $('#error-msg').html(ret);
                        setTimeout(function() {
                            $('#error-msg').html('');
                        }, 6000);
                    }
                });
            }
            return false;
        });
    }

    // exibe os cupons
    if ($('#cupom-success').length>0) {
        const urlParams = new URLSearchParams(window.location.search);
        const external_reference = urlParams.get('external_reference');
        if (external_reference) {
            $('#cupom-success').html('<br> Carregando. Aguarde! <br> <img src="https://cdn.shopify.com/s/files/1/0673/7208/9437/files/loading.gif?v=1775041902">');
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=cupom-success&external_reference='+external_reference,
                function(ret){
                    $('#cupom-success').html(ret);
                }
            );
        }
    }

    // pontos de venda (onde comprar)
    if ($('form#pdv').length>0) {
        var urlParams = new URLSearchParams(window.location.search);
        var estado = urlParams.get('estado');
        var cidade = urlParams.get('cidade');

        $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=get-clientes-ativos',
            function(ret){
                if ( ret.indexOf('option')>0 ) {
                    $('#estado').html(ret);
                }
                else {
                    $('#results').html('');
                }
            }
        );

        $(document).on('change','#estado',function(){
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=json-clientes-ativos&estado='+$('#estado').val(),
                function(ret){
                    if ( ret.options.indexOf('option')>0 ) {
                        $('#results').html('');
                        $('#results').html(ret.links);
                        $('#cidade').html(ret.options);
                        if (estado==null || estado!=$('#estado').val()) {
                            window.history.replaceState(null, '', '/pages/onde-encontrar/?estado='+$('#estado').val());
                        }
                    }
                    else {
                        $('#results').html('');
                    }
                },'json'
            );
        });

        $(document).on('change','#cidade',function(){
            cidadeChange();
        });
        
        if (estado!==null) {
            setTimeout(function(){
                $('#estado').val(estado).trigger('change');
                if (cidade!==null) {
                    setTimeout(function(){
                        $('#cidade').val(cidade);
                        cidadeChange();
                    }, 1000);
                }
            }, 1000);
        }

    }

    // mapa onde comprar
    if ($('#MapaBR').length>0) {
        $(document).on('click', 'area', function(){
            window.history.replaceState(null, '', '/pages/onde-encontrar/?estado='+$(this).attr('data-estado'));
            $('#estado').val($(this).attr('data-estado'));
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=json-clientes-ativos&estado='+$(this).attr('data-estado'),
                function(ret){
                    $('#results').html(ret.links);
                    $('#cidade').html(ret.options);
                }, 'json'
            );
            return false;
        });
        $(document).on('click','#results .button',function(){
            var estado = $(this).attr('data-estado');
            var cidade = $(this).attr('data-cidade');
            $('#cidade').val(cidade);
            $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=get-clientes-ativos&estado='+estado+'&cidade='+cidade,
                function(ret){
                    if ( ret.indexOf('div')>0 ) {
                        $('#results').html('');
                        $('#results').html(ret);
                        window.history.replaceState(null, '', '/pages/onde-encontrar/?estado='+estado+'&cidade='+cidade);
                    }
                    else {
                        $('#results').html('');
                    }
                }
            );
            return false;
        })
    }

    $('.button[href="https://goo.gl/maps/ec87Qs7zKVs8DQxNA"]').prop('target','_blank');
    $('.button[href="https://wa.me/5547997070273"]').prop('target','_blank');

})

function showCalendar() {
    $('#result').html('').hide();
    $('body,html').stop().animate({ scrollTop:$('#calendar').offset().top-100 }, 500, 'swing');
}

function cidadeChange(){
    $.post('https://www3.nugali.com.br/ajax/ajax-shopify.php?a=get-clientes-ativos&estado='+$('#estado').val()+'&cidade='+$('#cidade').val(),
        function(ret){
            if ( ret.indexOf('div')>0 ) {
                $('#results').html('');
                $('#results').html(ret);
                window.history.replaceState(null, '', '/pages/onde-encontrar/?estado='+$('#estado').val()+'&cidade='+$('#cidade').val());
            }
            else {
                $('#results').html('');
            }
        }
    );
}